import React from 'react';
import FormErrorMessage from './FormErrorMessage';

/**
 * Component wrapper cho form fields với error handling
 * @param {Object} props
 * @param {string} props.label - Label cho field
 * @param {boolean} props.required - Field có bắt buộc hay không
 * @param {string} props.error - Error message
 * @param {React.ReactNode} props.children - Form input element
 * @param {string} props.className - CSS class name
 * @param {Object} props.style - Inline styles
 * @param {boolean} props.preserveStyle - Giữ nguyên style gốc của container
 */
const FormField = ({ 
    label, 
    required = false, 
    error, 
    children, 
    className = '', 
    style = {},
    preserveStyle = false
}) => {
    // Nếu preserveStyle = true, chỉ wrap children và error, không thay đổi layout
    if (preserveStyle) {
        return (
            <>
                {children}
                <FormErrorMessage error={error} />
            </>
        );
    }

    const fieldStyle = {
        marginBottom: '16px',
        ...style
    };

    return (
        <div className={`form-field ${className}`} style={fieldStyle}>
            {label && (
                <label className="form-field__label">
                    {required && <span className="required-label">*</span>}
                    {label}
                </label>
            )}
            
            <div className="form-field__input">
                {children}
            </div>
            
            <FormErrorMessage error={error} />
        </div>
    );
};

export default FormField;
